import React, { useEffect } from "react";
import {
  spinnerBase,
  spinnerSizes,
  spinnerVariants,
  loadingSpinnerKeyframes,
} from "../../ui/FeedBack/loadingSpinnerTokens";

type SpinnerProps = {
  size?: keyof typeof spinnerSizes;
  variant?: keyof typeof spinnerVariants;
  ariaLabel?: string;
};

const LoadingSpinner: React.FC<SpinnerProps> = ({
  size = "md",
  variant = "default",
  ariaLabel = "Loading...",
}) => {
  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.innerHTML = loadingSpinnerKeyframes;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag); // ✅ This returns void
    };
  }, []);

  const style: React.CSSProperties = {
    ...spinnerBase,
    ...spinnerSizes[size],
    ...spinnerVariants[variant],
  };

  return <div style={style} aria-label={ariaLabel} />;
};

export default LoadingSpinner;
